import { useEffect, useState } from 'react'

export const useUserSummary = () => {
    const [userSummary, setUserSummary] = useState()

    useEffect(() => {
        window?.SF?.getUserSummary().then((summary) => setUserSummary(summary))
    }, [])

    return userSummary
}
